import { useEffect, useState, useRef } from 'react';
import { ConfigService } from '../services/config.service';

export const useMenu = ( items = [] ) => {

    const [componentes, setComponentes] = useState([]);

    const isMounted = useRef(true);

    useEffect(() => {

        ConfigService.getMenuOptions()
                .then( data => {
    
                    if ( isMounted.current ) {
                        setComponentes( data );
                    }
                });   

        return () => {

            isMounted.current = false;
        };
        
    }, []);

    useEffect(() => {
        
        if ( items.length > 0 ) {

            const itemsResult = ConfigService.setIconsOptions(items);
            setComponentes( itemsResult );
        }
        
    }, [items]);

    return componentes;
}

export default useMenu;
